import React from 'react';
import { Chip } from '@mui/material';
import { FiberManualRecordOutlined } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

// ── Status meta maps ──────────────────────────────────────────────────────────

export const EVENT_STATUS = {
  draft:     { color: '#e07b00', label: 'Draft' },
  published: { color: '#1075BA', label: 'Published' },
  ongoing:   { color: '#00a882', label: 'Ongoing' },
  completed: { color: '#4a6a85', label: 'Completed' },
  cancelled: { color: '#d32f2f', label: 'Cancelled' },
};

export const FORM_STATUS = {
  draft:     { color: '#e07b00', label: 'Draft' },
  published: { color: '#00a882', label: 'Published' },
  closed:    { color: '#4a6a85', label: 'Closed' },
  archived:  { color: '#888',    label: 'Archived' },
};

// ── Reusable StatusChip ───────────────────────────────────────────────────────

export function StatusChip({ status, map = EVENT_STATUS, size = 'small' }) {
  const s = map[status] || { color: '#888', label: status };
  return (
    <Chip
      size={size}
      icon={<FiberManualRecordOutlined sx={{ fontSize: '10px !important', color: `${s.color} !important` }} />}
      label={s.label}
      sx={{
        height: 22, fontSize: '0.72rem', fontWeight: 600,
        background: alpha(s.color, 0.09),
        color: s.color,
        border: `1px solid ${alpha(s.color, 0.25)}`,
        '& .MuiChip-icon': { color: 'inherit' },
      }}
    />
  );
}

// ── Format helpers ────────────────────────────────────────────────────────────

export const fmtDate = (d, opts = { month: 'short', day: 'numeric', year: 'numeric' }) =>
  d ? new Date(d).toLocaleDateString('en-US', opts) : '—';

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—';